import { modal } from "./modal";
import { el } from '../functions/create-element';
import { __ } from "../helpers/i18n";
export function addToFavorites(selector) {
    const buttons = document.querySelectorAll(selector ? `${selector} .add-to-favorites` : '.add-to-favorites');
    if (!buttons)
        return;
    buttons.forEach((button) => {
        if (!button.classList.contains('js-add-to-favorites')) {
            const product_id = button.getAttribute('data-product');
            const product_name = button.getAttribute('data-name');
            const product_variant = button.getAttribute('data-variant');
            const add_url = button.getAttribute('data-action-add');
            const remove_url = button.getAttribute('data-action-remove');
            const product = {
                id: product_id,
                variant: product_variant,
                name: product_name,
                add_url,
                remove_url,
            };
            button.addEventListener("click", () => handleFavorite(button, product));
            // Oznacz przycisk, że ma już event listener.
            button.classList.add('js-add-to-favorites');
        }
    });
    const handleFavorite = (button, product) => {
        button.setAttribute('disabled', '');
        const product_rel = button.getAttribute('data-rel');
        product_rel === 'add' ? add(button, product) : remove(button, product);
    };
    function add(button, product) {
        fetch(product.add_url, {
            method: 'POST',
            headers: {
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": token
            },
        })
            .then(response => response.json())
            .then(response => {
            button.setAttribute('data-rel', 'remove');
            button.setAttribute('title', 'Usuń z ulubionych');
            const message = el('div', {}, [
                el('span', {}, __('Produkt: ')),
                el('b', {}, `"${product.name}"`),
                el('span', {}, __(' został dodany do ulubionych'))
            ]);
            document.dispatchEvent(new CustomEvent('favorite.changed', { detail: { popup: 'add', id: product.id } }));
            modal(__('Produkt dodany do ulubionych'), message, 'icon--heart');
        })
            .catch(error => console.log(error))
            .finally(() => {
            button.removeAttribute('disabled');
        });
    }
    function remove(button, product) {
        fetch(product.remove_url, {
            method: 'POST',
            headers: {
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": token
            }
        })
            .then(response => response.json())
            .then(response => {
            button.setAttribute('data-rel', 'add');
            button.setAttribute('title', 'Dodaj do ulubionych');
            const reload_btn = button.getAttribute('data-reload');
            const message = el('div', {}, [
                el('span', {}, __('Produkt: ')),
                el('b', {}, `"${product.name}"`),
                el('span', {}, __(' został usunięty z ulubionych'))
            ]);
            document.dispatchEvent(new CustomEvent('favorite.changed', { detail: { popup: 'remove', id: product.id } }));
            modal(__('Produkt usunięty z ulubionych'), message, 'icon--heart');
            button.removeAttribute('disabled');
            if (reload_btn) {
                window.location.reload();
            }
        })
            .catch(error => console.log(error));
    }
}
